var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8748 36.9993C55.1298 36.9993 58.5523 33.546 58.5523 29.291C58.5523 25.036 55.1298 21.5827 50.8748 21.5827C46.6198 21.5827 43.1665 25.036 43.1665 29.291C43.1665 33.546 46.6198 36.9993 50.8748 36.9993ZM27.7498 33.916C32.8682 33.916 36.969 29.7843 36.969 24.666C36.969 19.5477 32.8682 15.416 27.7498 15.416C22.6315 15.416 18.4998 19.5477 18.4998 24.666C18.4998 29.7843 22.6315 33.916 27.7498 33.916ZM50.8748 43.166C45.2323 43.166 33.9165 46.0027 33.9165 51.6452V58.5827H67.8332V51.6452C67.8332 46.0027 56.5173 43.166 50.8748 43.166ZM27.7498 40.0827C20.5657 40.0827 6.1665 43.6902 6.1665 50.8743V58.5827H27.7498V51.6452C27.7498 49.0243 28.7673 44.4302 35.0573 40.946C32.3748 40.391 29.7848 40.0827 27.7498 40.0827Z",
    fill: "#69BEFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.8e941220abf98f021db80cd24dede023.svg";
export { ForwardRef as ReactComponent };